/* istanbul ignore file */
import { FormSection, FormRow, BigFormRow } from 'framework/ui/layout';
import { DateInput, TextArea, TextInput } from 'framework/form';
import TransferInput from 'domain/finance/journalEntry/shared/input/TransferInput';
import TransferListInput from 'domain/finance/journalEntry/shared/input/TransferListInput';
import ExchangeRateFormField from 'domain/finance/journalEntry/shared/input/ExchangeRateFormField';
import { EmployeeInput, OfficeCodeDropdown } from 'domain/shared/employee';
import JournalEntryProjectDropdown from '../shared/input/JournalEntryProjectDropdown';

const JournalEntryForm = ({
  isDisabled,
  isDisabledOffice = false,
}: {
  isDisabled?: boolean;
  isDisabledOffice?: boolean;
}) => {
  return (
    <>
      <FormSection>
        <FormRow>
          <DateInput label="Date" source="asDateOf" disabled={isDisabled} />
          <OfficeCodeDropdown source="attributes.office" label="Office" disabled={isDisabledOffice || isDisabled} />
        </FormRow>
        <BigFormRow>
          <TextArea source="description" disabled={isDisabled} />
        </BigFormRow>
        <TransferListInput
          source="transfers"
          inputTemplate={TransferInput}
          label="Transfers"
          addText="Add transfer"
          disabled={isDisabled}
          inputProps={{ disabled: isDisabled }}
        />
        <ExchangeRateFormField dateSource="asDateOf" />
      </FormSection>
      <FormSection
        title="Attributes"
        isVisible={(data: any) =>
          data.projectIsRequired || data.employeeAliasIsRequired || data.nonCommercialProjectIsRequired
        }
      >
        <FormRow>
          <JournalEntryProjectDropdown disabled={isDisabled} source="project.projectId" />
          <EmployeeInput
            source="attributes.employeeAlias"
            nameSource="attributes.employeeName"
            label="Worker"
            disabled={isDisabled}
            isVisible={(data: any) => data.employeeAliasIsRequired}
          />
          <TextInput
            source="projectName"
            label="Project name"
            isVisible={(data: any) => data.nonCommercialProjectIsRequired}
          />
        </FormRow>
      </FormSection>
    </>
  );
};

export default JournalEntryForm;
